/* eslint-disable max-len */
import {GeneralQuestions} from '../../../../../components/Forms/Constants/TCFD/General/GeneralQuestions';
import {inputType} from '../../../interface/inputType';

export const GovernanceTabQuestions = [
  {
    key: GeneralQuestions.QUESTION_GROUP_1.KEY,
    label: GeneralQuestions.QUESTION_GROUP_1.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.fieldLabel
          }
        ]
      }
    ]
  }
];

export const StrategyTabQuestions = [
  {
    key: GeneralQuestions.QUESTION_GROUP_2.KEY,
    label: GeneralQuestions.QUESTION_GROUP_2.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_3.fieldLabel
          }
        ]
      }
    ]
  }
];

export const RiskManagementTabQuestions = [
  {
    key: GeneralQuestions.QUESTION_GROUP_3.KEY,
    label: GeneralQuestions.QUESTION_GROUP_3.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_3.fieldLabel
          }
        ]
      }
    ]
  }
];

export const MetricsTargetsTabQuestions = [
  {
    key: GeneralQuestions.QUESTION_GROUP_4.KEY,
    label: GeneralQuestions.QUESTION_GROUP_4.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.fieldLabel
          },
          {
            fieldType: inputType.HEADING,
            heading:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.Question
          },
          {
            fieldType:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.fieldType,
            fieldName:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.fieldName,
            fieldLabel:
              GeneralQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_3.fieldLabel
          }
        ]
      }
    ]
  }
];
